import React from 'react';
import PropTypes from 'prop-types';
import PresetAmountButtons from './PresetAmountButtons';
import AmountCondensed from './AmountCondensed';
import AmountValidationError from './amountValidationError.js';
import templateData from '../../utility/getTemplateData';
import * as AppActions from '../../actions/AppActions';
import AppStore from '../../stores/AppStore';
import { StyleSheet, css } from 'aphrodite';
import * as FPT from '../../utility/fpt';

const STYLES = StyleSheet.create({
	errorContainer: {
		'text-align': 'center',
		'margin-top': '5px' 
	}
});


class PresetAmountRow extends React.Component {
	constructor(props) {
		super(props);
		this.presetAmounts = templateData.presetAmounts;

		this.state = {
			presetAmounts: this.presetAmounts,
			isPresetAmountSelected: templateData.donationAmountType === 'preset',
			selectedAmount: AppStore.getDonationAmountType() === 'preset' ?
				parseFloat(AppStore.getDonationAmount(), 10) :
				''
		}
	}

	fireEventForPresetAmountClick(amount) {
		const page = window.location.href.indexOf('guest') > -1 ?
			'guest' :
			'landing';
		FPT.trackLinkClickWithData('presetAmount', {
			amount: amount,
			page: page
		});
	}

	handlePresetAmountClick(event, value) {
		const presetAmounts = this.presetAmounts;
		const selectedAmount = value;

		this.fireEventForPresetAmountClick(selectedAmount);

		// Highlight the selected button
		this.setState({
			isPresetAmountSelected: true,
			presetAmounts,
			selectedAmount
		});
		// Clear the errors from amount field
		this.props.hideValidationError();

		AppActions.updateDonationAmountType('preset');
		this.props.handleAmountChange(`${selectedAmount}`);
	}

	clearSuggestedAmountSelection() {
		this.setState({
			selectedAmount: ''
		});
	}

	handleAmountChange(amount) {
		this.props.handleAmountChange(amount);
	}

	handleAmountFocus() {
		if (AppStore.getDonationAmountType() === 'preset') {
			this.clearSuggestedAmountSelection();
			AppActions.updateDonationAmountType('userinput');
			this.props.handleAmountChange('0.00');
		}

		this.props.handleAmountFocus();
	}

	render() {
		const isPresetAmountSelected = AppStore.getDonationAmountType() === 'preset';
		const amountFieldValue = isPresetAmountSelected ? '' : this.props.charityAmount;

		return (
            <div className="ppvx_col-sm-12">
				<div className="preset-amount-row-container">
					<div className="preset-amount-row">
						<div className="buttons-container">
							<PresetAmountButtons
								amounts={this.state.presetAmounts}
								selectedAmount={this.state.selectedAmount}
								symbol={this.props.charityAmountSymbol}
								charityAmountCode={this.props.charityAmountCode}
								handlePresetAmountClick={this.handlePresetAmountClick.bind(this)}
							/>
						</div>
						<div className="amount-container">
							<AmountCondensed
								amount={amountFieldValue}
								symbol={this.props.charityAmountSymbol}
								code={this.props.charityAmountCode}
								decimalPoint={this.props.decimalPoint}
								isEditable={this.props.isAmountEditable}
								handleAmount={this.handleAmountChange.bind(this)}
								handleAmountFocus={this.handleAmountFocus.bind(this)}
								showValidationError={this.props.showValidationError}
								validateDonationAmount={this.props.validateDonationAmount}
								validationErrorMessage={this.props.validationErrorMessage}
							/>
						</div>
					</div>
					{
						this.props.showValidationError ?
						<div className={`vx_has-error-with-message ${css(STYLES.errorContainer)}`}>
							<AmountValidationError
								errorString={this.props.validationErrorMessage}
								errorSourceField={'currencyAmount'}
								donationAmount={amountFieldValue}
							/>
						</div> :
						<span>&nbsp;</span>
					}
				</div>

			</div>
		)
	}
}

PresetAmountRow.propTypes = {
	hideValidationError: PropTypes.func,
	handleAmountChange: PropTypes.func,
	handleAmountFocus: PropTypes.func,
	charityAmount: PropTypes.string,
	showValidationError: PropTypes.bool,
	charityAmountSymbol: PropTypes.string,
	charityAmountCode: PropTypes.string,
	decimalPoint: PropTypes.string,
	isAmountEditable: PropTypes.bool,
	validateDonationAmount: PropTypes.func,
	validationErrorMessage: PropTypes.string
}
export default PresetAmountRow;
